<template>
	<div class="text-justify">
		<app-overlay-loader v-if="preloader" />
		<div class="row">
			<!-- Marketing Form -->
			<div class="col-lg-12">
				<form
					ref="refMarketingForm"
					:data-url="'/transaction/lead/' + value.id"
					class="mb-0"
					:class="{ 'loading-opacity': preloader }"
				>
					<div class="row">
						<!-- Inquiry Date -->
						<div class="col-md-4">
							<div class="form-group">
								<label>Inquiry Date</label>
								<app-input
									type="date"
									formName="marketingForm"
									v-model="marketingForm.created_at"
									:required="true"
									name="created_at"
									placeholder="Inquiry Date"
									:disabled="true"
								/>
							</div>
						</div>
						<!-- Inquiry Source -->
						<div class="col-md-4">
							<div class="form-group">
								<label>Inquiry Source</label>
								<app-input
									type="advance-search-select"
									formName="marketingForm"
									:loaded-per-time="10"
									v-model="input_inquiry_source"
									@input="setInquirySourceValue"
									fetch-url="master/inquiry-type"
									placeholder="Inquiry Source"
									list-value-field="name"
									required
								/>
							</div>
						</div>
						<!-- E-Tag -->
						<div class="col-md-4">
							<div class="form-group">
								<label>E-Tag</label>
								<app-input
									type="text"
									formName="marketingForm"
									placeholder="E-Tag"
									v-model="marketingForm.e_tag"
								/>
							</div>
						</div>
					</div>
					<!-- Submit and Clear button -->
					<div class="mt-5 mb-5 action-buttons">
						<button
							type="submit"
							class="btn btn-primary mr-2"
							:disabled="submitMarketingFormDisabled"
							@click.prevent="submitMarketingForm"
						>
							{{ $t("submit") }}
						</button>
						<!-- <button
							type="button"
							class="btn btn-secondary"
							@click="clearMarketingForm"
						>
							Clear
						</button> -->
					</div>
				</form>
			</div>
			<!-- How do you know about CLC Table -->
			<div class="col-lg-12">
				<div class="row mt-8 mb-8">
					<div class="col-md-12">
						<student-profile-tab-marketing-hdyk-table
							:value="value"
						/>
					</div>
				</div>
			</div>
			<!-- Marketing Additional Form -->
			<div class="col-lg-12">
				<form
					ref="refMarketingAdditionalForm"
					:data-url="'/transaction/lead/' + value.id"
					class="mb-0"
					:class="{ 'loading-opacity': preloader }"
				>
					<!-- I am interested in studying abroad - RADIO BUTTON -->
					<div class="row">
						<div class="col-md-8">
							<div class="form-group row">
								<label for="radioGroup" class="col-lg-4">
									I am interested in studying abroad
								</label>
								<div class="col-lg-3">
									<app-input
										type="radio"
										formName="marketingAdditionalForm"
										:list="yes_and_no_list"
										v-model="
											marketingAdditionalForm.is_interested_travel
										"
									/>
								</div>
								<!-- Countries -->
								<div
									class="col-md-5"
									v-if="
										marketingAdditionalForm.is_interested_travel ==
										1
									"
								>
									<div class="form-group">
										<app-input
											id="input_interested_countries"
											formName="marketingAdditionalForm"
											type="multi-select"
											:list="countryOrCityLists"
											:isAnimatedDropdown="true"
											v-model="
												marketingAdditionalForm.interested_countries
											"
											placeholder="Country or city of Destination"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Want to receive news/promo from CLC - RADIO BUTTON -->
					<div class="row">
						<div class="col-md-8">
							<div class="form-group row">
								<label for="radioGroup" class="col-lg-4">
									Want to receive news/promo from CLC
								</label>
								<div class="col-lg-3">
									<app-input
										type="radio"
										formName="marketingAdditionalForm"
										:list="yes_and_no_list"
										v-model="
											marketingAdditionalForm.is_subscribe
										"
									/>
								</div>
								<!-- Whatsapp Number or Email Address -->
								<div
									class="col-md-5"
									v-if="
										marketingAdditionalForm.is_subscribe ==
										1
									"
								>
									<div class="form-group">
										<app-input
											id="subscription_contact"
											formName="marketingAdditionalForm"
											type="text"
											placeholder="Whatsapp or Email Address"
											v-model="
												marketingAdditionalForm.subscription_contact
											"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Submit and Clear button -->
					<div class="mt-5 mb-5 action-buttons">
						<button
							type="submit"
							class="btn btn-primary mr-2"
							:disabled="submitMarketingAdditionalFormDisabled"
							@click.prevent="submitMarketingAdditionalForm"
						>
							{{ $t("submit") }}
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import { MarketingFormMixin } from "./MarketingFormMixin.js";
import { MarketingAdditionalFormMixin } from "./MarketingAdditionalFormMixin.js";
import GlobalHelperMixin from "../../../../../../../Mixins/global/GlobalHelperMixin";

export default {
	name: "StudentTabMarketing",
	mixins: [
		MarketingFormMixin,
		MarketingAdditionalFormMixin,
		GlobalHelperMixin,
	],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			sameAsAbove: false,
			submitMarketingFormDisabled: true,
			originalMarketingForm: {},
			submitMarketingAdditionalFormDisabled: true,
			originalMarketingAdditionalForm: {},
			marketingForm: {
				created_at: this.value.created_at,
				inquiry_type_id: this.value.inquiry_type_id,
				e_tag: this.value.e_tag,
			},
			marketingAdditionalForm: {
				is_interested_travel: this.value.is_interested_travel ?? 0,
				interested_countries: this.value.interested_countries,
				is_subscribe: this.value.is_subscribe ?? 0,
				subscription_contact: this.value.subscription_contact,
			},
			countryOrCityLists: [],
			input_inquiry_source: this.value
				? this.value.inquiry_source
					? {
							id: this.value.inquiry_source.id || 0,
							name: this.value.inquiry_source.name || "",
					  }
					: {
							id: this.value.inquiry_source?.id || 0,
							name: this.value.inquiry_source?.name || "",
					  }
				: {
						id: this.value.inquiry_source.id || 0,
						name: this.value.inquiry_source.name || "",
				  },
			yes_and_no_list: [
				{ id: 0, value: "No" },
				{ id: 1, value: "Yes" },
			],
		};
	},
	created() {
		this.fetchData();
		this.originalMarketingForm = JSON.parse(
			JSON.stringify(this.marketingForm)
		);
		this.originalMarketingAdditionalForm = JSON.parse(
			JSON.stringify(this.marketingAdditionalForm)
		);
	},
	methods: {
		async fetchData() {
			try {
				let [countryResponse, cityResponse] = await Promise.all([
					axios.get("/master/country"),
					axios.get("/master/city?per_page=500"),
				]);

				countryResponse.data.data.forEach((item) => {
					this.countryOrCityLists.push({
						id: item.name,
						value: item.name,
					});
				});

				cityResponse.data.data.forEach((item) => {
					this.countryOrCityLists.push({
						id: item.name,
						value: item.name,
					});
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},

		// MARKETING FORM
		beforeSubmitMarketingForm() {
			this.preloader = true;
		},
		submitMarketingForm() {
			// Handle form submission here
			this.originalMarketingForm = JSON.parse(
				JSON.stringify(this.marketingForm)
			);
			this.submitMarketingFormDisabled =
				JSON.stringify(this.marketingForm) ===
				JSON.stringify(this.originalMarketingForm);
			this.saveMarketingForm(this.marketingForm);
		},
		afterSuccessMarketingForm(res) {
			this.$toastr.s(res.data.message);
			// this.clearMarketingForm();
		},
		afterFinalResponseMarketingForm() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterErrorMarketingForm(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clearMarketingForm() {
			// Clear form fields here
			this.marketingForm = {};
			// this.basicInfo.custom_file = null;
		},

		setInquirySourceValue(data) {
			if (data && data.hasOwnProperty("id")) {
				this.marketingForm.inquiry_type_id = data.id;
			}
		},

		// MARKETING ADDITIONAL FORM
		beforeSubmitMarketingAdditionalForm() {
			this.preloader = true;
		},
		submitMarketingAdditionalForm() {
			// Handle form submission here
			const fieldsToCheck = [
				{
					condition:
						this.marketingAdditionalForm.is_interested_travel == 1,
					requiredFields: ["interested_countries"],
					errorMessage:
						"Please select Country or City of Destination",
				},
				{
					condition: this.marketingAdditionalForm.is_subscribe == 1,
					requiredFields: ["subscription_contact"],
					errorMessage: "Please fill subscription contact",
				},
			];

			let allFieldsValid = true; // Assume all fields are valid initially

			for (const fieldGroup of fieldsToCheck) {
				if (fieldGroup.condition) {
					for (const field of fieldGroup.requiredFields) {
						if (!this.marketingAdditionalForm[field]) {
							this.$toastr.e(
								fieldGroup.errorMessage.replace(
									"{field}",
									field.replace("_", " ")
								)
							);
							allFieldsValid = false; // Set to false if any field is not valid
						}
					}
				}
			}

			if (allFieldsValid) {
				this.originalMarketingAdditionalForm = JSON.parse(
					JSON.stringify(this.marketingAdditionalForm)
				);
				this.submitMarketingAdditionalFormDisabled =
					JSON.stringify(this.marketingAdditionalForm) ===
					JSON.stringify(this.originalMarketingAdditionalForm);

				this.saveMarketingAdditionalForm(this.marketingAdditionalForm);
			}
		},
		afterSuccessMarketingAdditionalForm(res) {
			this.$toastr.s(res.data.message);
			// this.clearMarketingAdditionalForm();
		},
		afterFinalResponseMarketingAdditionalForm() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterErrorMarketingAdditionalForm(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clearMarketingAdditionalForm() {
			// Clear form fields here
			this.marketingAdditionalForm = {};
			// this.basicInfo.custom_file = null;
		},
	},
	watch: {
		marketingForm: {
			handler: function (val) {
				// Check if marketingForm has changed
				const isMarketingFormChanged =
					JSON.stringify(val) !==
					JSON.stringify(this.originalMarketingForm);

				// Update the submitMarketingFormDisabled based on the change status
				this.submitMarketingFormDisabled = !isMarketingFormChanged;
			},
			deep: true,
		},
		marketingAdditionalForm: {
			handler: function (val) {
				val.is_interested_travel = parseInt(val.is_interested_travel);

				// Check if marketingAdditionalForm has changed
				const isMarketingAdditionalFormChanged =
					JSON.stringify(val) !==
					JSON.stringify(this.originalMarketingAdditionalForm);

				// Update the submitMarketingAdditionalFormDisabled based on the change status
				this.submitMarketingAdditionalFormDisabled =
					!isMarketingAdditionalFormChanged;
			},
			deep: true,
		},
	},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 40px;
}
.mb-8 {
	margin-bottom: 40px;
}
.form-control {
	border: 3px solid; /* You can adjust the border color and width as needed = #c41a1a !important; */
}
</style>
